export default {"src":"/_next/static/media/icon-address.d0d313da.svg","height":18,"width":12,"blurWidth":0,"blurHeight":0};